module.exports = __webpack_public_path__ + "static/img/top-img.cd2f0fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/detailpic/UL168/top-img.jpg
// module id = iDSC
// module chunks = 51